import { FaTimes, FaUser, FaIdCard, FaMapMarkerAlt, FaPhone, FaFileAlt, FaEdit } from 'react-icons/fa';
import { formatarCpfCnpj, formatarTelefone } from '../utils/validators';

const ClientModal = ({ cliente, onClose, onVerDocumentos, onEditar }) => {
  if (!cliente) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="bg-blue-600 text-white p-6 rounded-t-lg flex items-center justify-between">
          <h2 className="text-2xl font-bold">Detalhes do Cliente</h2>
          <button
            onClick={onClose}
            className="hover:bg-blue-700 p-2 rounded-full transition duration-200"
          >
            <FaTimes size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Nome */}
          <div className="flex items-start space-x-3">
            <div className="bg-blue-100 p-3 rounded-lg">
              <FaUser className="text-blue-600 text-xl" />
            </div>
            <div className="flex-1">
              <label className="text-sm font-medium text-gray-500 uppercase">Nome Completo</label>
              <p className="text-lg font-semibold text-gray-800 mt-1">{cliente.nome}</p>
            </div>
          </div>

          {/* CPF/CNPJ */}
          {cliente.cpf_cnpj && (
            <div className="flex items-start space-x-3">
              <div className="bg-green-100 p-3 rounded-lg">
                <FaIdCard className="text-green-600 text-xl" />
              </div>
              <div className="flex-1">
                <label className="text-sm font-medium text-gray-500 uppercase">CPF/CNPJ</label>
                <p className="text-lg font-semibold text-gray-800 mt-1">{formatarCpfCnpj(cliente.cpf_cnpj)}</p>
              </div>
            </div>
          )}

          {/* Endereço */}
          {cliente.endereco && (
            <div className="flex items-start space-x-3">
              <div className="bg-purple-100 p-3 rounded-lg">
                <FaMapMarkerAlt className="text-purple-600 text-xl" />
              </div>
              <div className="flex-1">
                <label className="text-sm font-medium text-gray-500 uppercase">Endereço</label>
                <p className="text-lg text-gray-800 mt-1">{cliente.endereco}</p>
              </div>
            </div>
          )}

          {/* Telefone */}
          {cliente.telefone && (
            <div className="flex items-start space-x-3">
              <div className="bg-orange-100 p-3 rounded-lg">
                <FaPhone className="text-orange-600 text-xl" />
              </div>
              <div className="flex-1">
                <label className="text-sm font-medium text-gray-500 uppercase">Telefone</label>
                <p className="text-lg text-gray-800 mt-1">{formatarTelefone(cliente.telefone)}</p>
              </div>
            </div>
          )}

          {/* Documentos */}
          <div className="flex items-start space-x-3">
            <div className="bg-red-100 p-3 rounded-lg">
              <FaFileAlt className="text-red-600 text-xl" />
            </div>
            <div className="flex-1">
              <label className="text-sm font-medium text-gray-500 uppercase">Documentos</label>
              <p className="text-lg text-gray-800 mt-1">
                {cliente.total_documentos} {cliente.total_documentos === 1 ? 'documento' : 'documentos'}
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 p-6 rounded-b-lg flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold rounded-lg transition duration-200"
          >
            Fechar
          </button>
          <button
            onClick={() => { onClose(); onEditar(cliente); }}
            className="px-6 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-lg transition duration-200 flex items-center space-x-2"
          >
            <FaEdit />
            <span>Editar</span>
          </button>
          <button
            onClick={() => onVerDocumentos(cliente)}
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition duration-200"
          >
            Ver Documentos
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientModal;
